import React, { useState, useRef } from "react";
import "./Recommendation.scss";
import dog from "../../../assets/images/simulatorDog.png";
import cat from "../../../assets/images/simulatorCat.png";
import { useTranslation } from "react-i18next";
import InputMask from "react-input-mask";
import { Link, useNavigate } from "react-router-dom";
import { useAuthValidation } from "../../../hooks/useAuthValidation";
import DefaultLayout from "../../components/Layouts/DefaultLayout";
import api from "../../../services/api";
import apiSimulator from "../../../services/apiSimulator";
import Select from "react-select";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination } from "swiper/modules";

function Recommendation() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user, loading } = useAuthValidation();
  const formTarget = useRef(null);
  const [productsResult, setProductsResult] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [errors, setErrors] = useState({});
  const [whatsData, setWhatsData] = useState({ whatsapp: "", products: [] });
  const [petName, setPetName] = useState("");
  const [accept_communications, setAccept_communications] = useState("");
  const [email_not_provided, setEmail_not_provided] = useState("");
const [isClearing, setIsClearing] = useState(false);

const COUNTRY_OPTIONS = [
  { label: "Brasil", value: "Brasil" },
  { label: "Argentina", value: "Argentina" },
  { label: "Paraguay", value: "Paraguay" },
  { label: "Uruguay", value: "Uruguay" },
  { label: "Colombia", value: "Colombia" },
];

  const [formData, setFormData] = useState({
    pet: "",
    phase: "",
    weight: "",
    age: "",
    castrated: "",
    overweight: "",
    ideal_weight: "",
    lactating_puppies: "",
    lactating_weeks: "",
  });
  const [formClientData, setFormClientData] = useState({
    name: "",
    email: "",
    phone: "",
    cep: "",
    country: "",
    accept_communications: false,
    email_not_provided: false,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedKey, setSelectedKey] = useState(null);
  const [error, setError] = useState(null);

  // Enquanto estiver carregando a validação de autenticação, mostra loading
  if (loading) {
    return <div className="loading">{t("loading")}</div>;
  }

  // Se não houver usuário autenticado, não renderiza nada (hook já faz redirecionamento)
  if (!user) {
    return null;
  }

  const scrollToDiv = () => {
    setTimeout(() => {
      if (formTarget.current) {
        formTarget.current.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 200);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
    setProductsResult(null);
  };

  const handleChangeClient = (e) => {
    const { name, value } = e.target;
    setFormClientData((prevFormClientData) => ({
      ...prevFormClientData,
      [name]: value,
    }));
  };

  const handleChangePet = (e) => {
    setPetName(e.target.value);
  };

  const handleProductSelect = (key) => {
    setSelectedKey(key);
    setSelectedProduct({
      id: key,
      cod: productsResult[key].id,
      brand: productsResult[key].brand,
      title: productsResult[key].title,
      energy: productsResult[key].energy,
      portion: productsResult[key].portion,
      color: productsResult[key].hexadecimal,
      slug: productsResult[key].slug,
    });
  };

  const handleCheckboxChangeEmail = (event) => {
    const isChecked = event.target.checked;
    setFormClientData((prevFormClientData) => ({
      ...prevFormClientData,
      email_not_provided: isChecked,
    }));
    setErrors((prevErrors) => ({ ...prevErrors, email_not_provided: null }));
  };

  const handleCheckboxChange = (event) => {
    const isChecked = event.target.checked;
    setFormClientData((prevFormClientData) => ({
      ...prevFormClientData,
      accept_communications: isChecked,
    }));
    setErrors((prevErrors) => ({ ...prevErrors, accept_communications: null }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);

    // Usa apiSimulator ao invés de simulatorAxios.
    // Não precisa setar headers aqui, interceptors já cuidam de Language.
    apiSimulator
      .post("/simulator", formData)
      .then((response) => {
        setProductsResult(response.data);
        console.log(response.data)
        setIsLoading(false);
        // const mappedProducts = Object.keys(response.data).map((key) => {
        //   const product = response.data[key];
        //   return {
        //     name: `${product.brand} ${product.title}`,
        //     portion: product.portion,
        //     link: product.slug,
        //   };
        // });
        // setWhatsData((prev) => ({
        //   ...prev,
        //   products: mappedProducts,
        // }));
      })
      .catch((error) => {
        console.error("Erro ao enviar os dados:", error);
        setIsLoading(false);
      });
  };

  const handleSubmitWhats = async (e) => {
    if (isSending) return;
    setIsSending(true);
    e.preventDefault();
    setErrors({});
    const { name, email, phone, cep, accept_communications, email_not_provided } = formClientData;
    const { pet, phase, weight, age, castrated, overweight, ideal_weight, lactating_puppies, lactating_weeks } =
    formData;

    const payload = {
      name,
      email,
      phone,
      cep,
      accept_communications,
      email_not_provided,
      pet_name: petName,
      pet: pet,
      phase: phase,
      weight: weight,
      age: age,
      castrated: castrated,
      overweight: overweight,
      ideal_weight: ideal_weight,
      lactating_puppies: lactating_puppies,
      lactating_weeks: lactating_weeks,
      product: selectedProduct.title,
      product_id: selectedProduct.cod,
      product_brand: selectedProduct.brand,
      daily_dose: selectedProduct.portion,
    };

    console.log(payload);
    if (!selectedProduct) {
      alert(t("recommendation-select-product-alert"));
      return;
    }

    api
    .post("/lead/create", payload)
    .then((response) => {
      const formattedPhoneNumber = phone.replace(/\D/g, "");

    const message = t("recommendation-whatsapp-message", {
      petName,
      brand: selectedProduct.brand,
      title: selectedProduct.title,
      portion: selectedProduct.portion,
      slug: selectedProduct.slug,
    });

    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${formattedPhoneNumber}?text=${encodedMessage}`;
    window.open(whatsappUrl, "_blank");

      setTimeout(() => {
        navigate("/documento-cadastrado");
      }, 1000);
    })
    .catch((error) => {
      console.error("Erro ao enviar os dados para a API:", error);
      if (error.response && error.response.data) {
        const serverErrors = error.response.data;
        const formattedErrors = Object.fromEntries(Object.entries(serverErrors).map(([key, value]) => [key, value[0]]));
        setErrors(formattedErrors);
      } else {
        setErrors({ general: t("common-submit-error") });
      }
    })
    .finally(() => {
      setIsSending(false);
    });
  };

  return (
    <DefaultLayout>
      <section className="simulator">
        <div className="container">
          <h2>{t("simulator-title")}</h2>
          <form onSubmit={handleSubmit} className="simulator-form">
            <div className="pet-name">
              <input name="petName" type="text" placeholder={t("recommendation-pet-name-placeholder")} onChange={handleChangePet} />
                {errors.pet_name && <p className="error">{errors.pet_name}</p>}
            </div>
            {/* Primeira fase - tipo de animal */}
            <div className="pet">
              <div className="grid">
                <label className="column pet-container">
                  <div className="pet-image-container">
                    <img src={dog} />
                  </div>
                  <div className="row">
                    <input
                      type="radio"
                      name="pet"
                      value="dog"
                      checked={formData.pet === "dog"}
                      onChange={handleChange}
                    />
                    <span>{t("simulator-pet-1")}</span>
                  </div>
                </label>
                <label className="column pet-container">
                  <div className="pet-image-container">
                    <img src={cat} />
                  </div>
                  <div className="row">
                    <input
                      type="radio"
                      name="pet"
                      value="cat"
                      checked={formData.pet === "cat"}
                      onChange={handleChange}
                    />
                    <span>{t("simulator-pet-2")}</span>
                  </div>
                </label>
              </div>
            </div>

            {/* Segunda fase - idade */}
            {formData.pet && (
              <div className="stage">
                <div className="grid">
                  <label className="row">
                    <input
                      type="radio"
                      name="phase"
                      value="puppies"
                      checked={formData.phase === "puppies"}
                      onChange={handleChange}
                    />
                    <span>{t("simulator-pet-phase-1")}</span>
                  </label>
                  <label className="row">
                    <input
                      type="radio"
                      name="phase"
                      value="adults"
                      checked={formData.phase === "adults"}
                      onChange={handleChange}
                    />
                    <span>{t("simulator-pet-phase-2")}</span>
                  </label>
                  <label className="row">
                    <input
                      type="radio"
                      name="phase"
                      value="pregnant"
                      checked={formData.phase === "pregnant"}
                      onChange={handleChange}
                    />
                    <span>{t("simulator-pet-phase-3")}</span>
                  </label>
                  <label className="row">
                    <input
                      type="radio"
                      name="phase"
                      value="lactating"
                      checked={formData.phase === "lactating"}
                      onChange={handleChange}
                    />
                    <span>{t("simulator-pet-phase-4")}</span>
                  </label>
                </div>
              </div>
            )}

            {/* Terceira fase - peso */}
            {formData.pet && formData.phase && (
              <div className="weight">
                <div>
                  <input
                    placeholder={t("simulator-pet-weight")}
                    type="number"
                    name="weight"
                    value={formData.weight}
                    onChange={handleChange}
                  />
                </div>
                {formData.pet === "dog" && formData.phase === "puppies" && (
                  <p className="puppy-weight">{t("simulator-pet-weight-obs")}</p>
                )}
              </div>
            )}

            {/* cat */}
            {/* cat filhote - idade */}
            {formData.pet === "cat" && formData.phase === "puppies" && formData.weight && (
              <div className="age">
                <div className="grid">
                  <label className="row">
                    <input type="radio" name="age" value="1" checked={formData.age === "1"} onChange={handleChange} />
                    <span>{t("simulator-cat-age-1")}</span>
                  </label>
                  <label className="row">
                    <input type="radio" name="age" value="2" checked={formData.age === "2"} onChange={handleChange} />
                    <span>{t("simulator-cat-age-2")}</span>
                  </label>
                  <label className="row">
                    <input type="radio" name="age" value="3" checked={formData.age === "3"} onChange={handleChange} />
                    <span>{t("simulator-cat-age-3")}</span>
                  </label>
                </div>
              </div>
            )}

            {formData.pet === "cat" && formData.phase === "adults" && formData.weight && (
              <div className="castrated">
                <h2>{t("simulator-pet-cat-castrated")}</h2>
                <div className="grid">
                  <label className="row">
                    <input
                      type="radio"
                      name="castrated"
                      value="1"
                      checked={formData.castrated === "1"}
                      onChange={handleChange}
                    />
                    <span>{t("simulator-yes")}</span>
                  </label>
                  <label className="row">
                    <input
                      type="radio"
                      name="castrated"
                      value="0"
                      checked={formData.castrated === "0"}
                      onChange={handleChange}
                    />
                    <span>{t("simulator-no")}</span>
                  </label>
                </div>
              </div>
            )}

            {formData.pet === "cat" && formData.phase === "adults" && formData.weight && formData.castrated && (
              <div className="overweight">
                <h2>{t("simulator-overweight-title")}</h2>
                <div className="grid">
                  <label className="row">
                    <input
                      type="radio"
                      name="overweight"
                      value="1"
                      checked={formData.overweight === "1"}
                      onChange={handleChange}
                    />
                    <span>{t("simulator-yes")}</span>
                  </label>
                  <label className="row">
                    <input
                      type="radio"
                      name="overweight"
                      value="0"
                      checked={formData.overweight === "0"}
                      onChange={handleChange}
                    />
                    <span>{t("simulator-no")}</span>
                  </label>
                </div>
              </div>
            )}

            {formData.pet === "cat" &&
              formData.phase === "adults" &&
              formData.weight &&
              formData.castrated &&
              formData.overweight === "1" && (
                <div className="ideal-weight">
                  <input
                    type="number"
                    placeholder={t("simulator-ideal-weight")}
                    name="ideal_weight"
                    value={formData.ideal_weight}
                    onChange={handleChange}
                  />
                </div>
              )}

            {/* dog */}
            {/* dog filhote - idade */}
            {formData.pet === "dog" && formData.phase === "puppies" && formData.weight && (
              <div className="age">
                <div className="grid">
                  <label className="row">
                    <input type="radio" name="age" value="1" checked={formData.age === "1"} onChange={handleChange} />
                    <span>{t("simulator-dog-age-1")}</span>
                  </label>
                  <label className="row">
                    <input type="radio" name="age" value="2" checked={formData.age === "2"} onChange={handleChange} />
                    <span>{t("simulator-dog-age-2")}</span>
                  </label>
                  <label className="row">
                    <input type="radio" name="age" value="3" checked={formData.age === "3"} onChange={handleChange} />
                    <span>{t("simulator-dog-age-3")}</span>
                  </label>
                </div>
              </div>
            )}

            {formData.pet === "dog" && formData.phase === "adults" && formData.weight && (
              <div className="overweight">
                <h2>{t("simulator-overweight-title")}</h2>
                <div className="grid">
                  <label className="row">
                    <input
                      type="radio"
                      name="overweight"
                      value="1"
                      checked={formData.overweight === "1"}
                      onChange={handleChange}
                    />
                    <span>{t("simulator-yes")}</span>
                  </label>
                  <label className="row">
                    <input
                      type="radio"
                      name="overweight"
                      value="0"
                      checked={formData.overweight === "0"}
                      onChange={handleChange}
                    />
                    <span>{t("simulator-no")}</span>
                  </label>
                </div>
              </div>
            )}

            {formData.pet === "dog" &&
              formData.phase === "adults" &&
              formData.weight < 12 &&
              formData.overweight === "0" && (
                <div className="age">
                  <div className="grid">
                    <label className="row">
                      <input
                        type="radio"
                        name="age"
                        value="adults"
                        checked={formData.age === "adults"}
                        onChange={handleChange}
                      />
                      <span>{t("simulator-dog-age-1-1")}</span>
                    </label>
                    <label className="row">
                      <input
                        type="radio"
                        name="age"
                        value="senior"
                        checked={formData.age === "senior"}
                        onChange={handleChange}
                      />
                      <span>{t("simulator-dog-age-1-2")}</span>
                    </label>
                  </div>
                </div>
              )}

            {formData.pet === "dog" &&
              formData.phase === "adults" &&
              formData.weight >= 12 &&
              formData.overweight === "0" && (
                <div className="age">
                  <div className="grid">
                    <label className="row">
                      <input
                        type="radio"
                        name="age"
                        value="adults"
                        checked={formData.age === "adults"}
                        onChange={handleChange}
                      />
                      <span>{t("simulator-dog-age-2-1")}</span>
                    </label>
                    <label className="row">
                      <input
                        type="radio"
                        name="age"
                        value="senior"
                        checked={formData.age === "senior"}
                        onChange={handleChange}
                      />
                      <span>{t("simulator-dog-age-2-2")}</span>
                    </label>
                  </div>
                </div>
              )}

            {formData.pet === "dog" &&
              formData.phase === "adults" &&
              formData.weight &&
              formData.overweight === "1" && (
                <div className="ideal-weight">
                  <input
                    placeholder={t("simulator-ideal-weight")}
                    type="number"
                    name="ideal_weight"
                    value={formData.ideal_weight}
                    onChange={handleChange}
                  />
                </div>
              )}

            {formData.pet === "dog" && formData.phase === "lactating" && formData.weight && (
              <div className="puppy-number">
                <input
                  placeholder={t("simulator-babies")}
                  type="text"
                  name="lactating_puppies"
                  value={formData.lactating_puppies}
                  onChange={handleChange}
                />
              </div>
            )}

            {formData.pet === "dog" &&
              formData.phase === "lactating" &&
              formData.weight &&
              formData.lactating_puppies && (
                <div className="lactating-week">
                  <div className="grid">
                    <label className="row">
                      <input
                        type="radio"
                        name="lactating_weeks"
                        value="1"
                        checked={formData.lactating_weeks === "1"}
                        onChange={handleChange}
                      />
                      <span>{t("simulator-dog-lactating-1")}</span>
                    </label>
                    <label className="row">
                      <input
                        type="radio"
                        name="lactating_weeks"
                        value="2"
                        checked={formData.lactating_weeks === "2"}
                        onChange={handleChange}
                      />
                      <span>{t("simulator-dog-lactating-2")}</span>
                    </label>
                    <label className="row">
                      <input
                        type="radio"
                        name="lactating_weeks"
                        value="3"
                        checked={formData.lactating_weeks === "3"}
                        onChange={handleChange}
                      />
                      <span>{t("simulator-dog-lactating-3")}</span>
                    </label>
                  </div>
                </div>
              )}
            <button type="submit" disabled={isLoading}>
              {isLoading ? t("calc-button") : t("simulator-button")}
            </button>
          </form>

          {productsResult && (
            <div className="simulator-result">
              <h3>{t("simulator-result")}</h3>
              <Swiper spaceBetween={20} slidesPerView={3} navigation modules={[Navigation, Pagination]}
                breakpoints={{
                  0: {
                    slidesPerView: 1,
                  },
                  1024: {
                    slidesPerView: 3,
                  },
                }}>
                {Object.keys(productsResult).map((key) => (
                  <SwiperSlide key={key} style={{ borderColor: selectedKey === key ? productsResult[key].hexadecimal : "#FFF" }}
                    className={selectedKey === key ? "selected" : ""}>
                    <label onClick={scrollToDiv}>
                      <img src={productsResult[key].image.link} alt={productsResult[key].brand} />
                      <h4>{productsResult[key].brand}</h4>
                      <p>
                        {t("simulator-result-dose")}
                        <span style={{ color: productsResult[key].hexadecimal, borderColor: productsResult[key].hexadecimal }}>
                          {productsResult[key].portion} {t("simulator-result-grams")}
                        </span>
                      </p>
                      <div className="row">
                        <input
                          type="radio"
                          name="productSelect"
                          value={key}
                          checked={selectedProduct?.id === key}
                          onChange={() => handleProductSelect(key)}
                          hidden/>
                        <span
                          style={{ background: productsResult[key].hexadecimal, borderColor: productsResult[key].hexadecimal }}>
                          {t("recommendation-send-whatsapp")}
                        </span>
                      </div>
                    </label>
                  </SwiperSlide>
                ))}
              </Swiper>
              <p>{t("simulator-result-text")}</p>
            </div>
          )}
          {selectedKey && (
            <form onSubmit={handleSubmitWhats} className="simulator-client-data" ref={formTarget}>
              <p>{t("simulator-result-send")}</p>
              <div>
                <input
                  name="name"
                  type="text"
                  placeholder={t("form-prescription-input-1")}
                  onChange={handleChangeClient}/>
                {errors.name && <p className="error">{errors.name}</p>}
              </div>
              <div>
                <Select
                  options={COUNTRY_OPTIONS}
                  classNamePrefix="select"
                  placeholder={t("new-account-select-country")}
                  value={COUNTRY_OPTIONS.find((opt) => opt.value === formClientData.country) || null}
                  onChange={(option) => {
                    setFormClientData((prev) => ({
                      ...prev,
                      country: option ? option.value : "",
                    }));
                    setErrors((prevErrors) => ({ ...prevErrors, country: null }));
                  }}
                />
                {errors.country && <p className="error">{errors.country}</p>}
              </div>
              <div>
                <InputMask
                  key={`phone-${formClientData.country}-${isClearing}`}
                  mask={
                    (!isClearing
                      ? formClientData.country === "Brasil"
                      ? "+55 (99) 99999-9999"
                      : formClientData.country === "Argentina"
                      ? "+99 (999) 9999-9999"
                      : formClientData.country === "Paraguay"
                      ? "+999 (999) 999-999"
                      : formClientData.country === "Colombia"
                      ? "+57 999 999 9999"
                      : formClientData.country === "Uruguay"
                      ? "+598 999 999 999"
                      : ""
                      : "") || false
                  }
                  placeholder={t("simulator-result-send-input")}
                  onChange={handleChangeClient}
                  name="phone"
                  type="text"
                  value={formClientData.phone}
                />
                {errors.phone && <p className="error">{errors.phone}</p>}
              </div>
              <div>
                <input
                  name="email"
                  type="email"
                  placeholder={t("form-prescription-input-4")}
                  onChange={handleChangeClient}/>
                {errors.email && <p className="error">{errors.email}</p>}
              </div>
              <div>
                <InputMask
                  key={`phone-${formClientData.country}-${isClearing}`}
                  mask={
                    (!isClearing
                      ? formClientData.country === "Brasil"
                      ? "99999-999"
                      : formClientData.country === "Paraguay"
                      ? "99999"
                      : formClientData.country === "Colombia"
                      ? "999999"
                      : formClientData.country === "Uruguay"
                      ? "99999"
                      : ""
                      : "") || false
                  }
                  name="cep"
                  type="text"
                  placeholder={t("form-prescription-input-6")}
                  onChange={handleChangeClient}
                  value={formClientData.cep}
                />
                {errors.cep && <p className="error">{errors.cep}</p>}
              </div>
              <div className="empty-email">
                <label className="row">
                  <input
                    type="checkbox"
                    onChange={handleCheckboxChangeEmail}
                    checked={formClientData.email_not_provided || false}
                    name="email_not_provided"/>
                  <span>{t("recommendation-email-not-available")}</span>
                </label>
                {errors.email_not_provided && <p className="error">{errors.email_not_provided}</p>}
              </div>
              <div className="accept-communications">
                <label className="row">
                  <input
                    type="checkbox"
                    onChange={handleCheckboxChange}
                    checked={formClientData.accept_communications || false}
                    name="accept_communications"/>
                  <span>{t("recommendation-accept-communications")}</span>
                </label>
                {errors.accept_communications && <p className="error">{errors.accept_communications}</p>}
              </div>
              {errors.general && <p className="error">{errors.general}</p>}
              {error && <p className="error">{error}</p>}
              <button type="submit" disabled={isSending}>
                {isSending ? t("simulator-result-sending-button") : t("simulator-result-send-button")}
              </button>
            </form>
          )}
        </div>
      </section>
    </DefaultLayout>
  );
}

export default Recommendation;